// Centralized axios config helper to ensure cookies are sent and Authorization is omitted for guests.
import axios from 'axios';

export const getAxiosConfig = (state, opts = {}) => {
  const { withCredentials = true, forbidAuthForGuest = true, headers: extraHeaders = {} } = opts;
  const userInfo = state?.user?.userInfo;
  const isGuest = !!userInfo?.isGuest;
  const headers = { 'Content-Type': 'application/json', ...extraHeaders };

  // Attach Authorization only for non-guest users with a token
  if (!forbidAuthForGuest || !isGuest) {
    const token = userInfo?.token;
    if (token) headers.Authorization = `Bearer ${token}`;
  }

  return { headers, withCredentials };
};

export const clearAxiosAuthorization = () => {
  try {
    if (axios.defaults?.headers?.common?.Authorization) {
      delete axios.defaults.headers.common.Authorization;
    }
  } catch {}
};
